/*
    CAUTION: PLEASE READ! This File was auto generated by the system.
    Any changes you make will be removed the next time it's generated.
*/
import {
ExternalAppItemService         
,ExternalAppSettingItemService         
,ExternalSystemItemService         
,ExternalSystemDirtyRecordItemService
,ExternalSystemDirtyScanStateItemService
,MigrationProjectItemService
,AIPromptItemService         
,AILevelProfileItemService         
,ConvokeAppConfigItemService         
,DataTypeItemService         
,EntityMasterRecordItemService         
,EntityMasterRecordMapItemService         
,EntityObjectFieldMapItemService         
 ,EntityObjectItemService         
 ,EntityQueryItemService         
 ,RemoteBatchHostItemService
 ,APIEndpointBatchHostItemService
 ,BatchManagementPreferenceItemService
 ,ClientBillingProfileItemService
 ,SchemaItemService         
,IntegrationItemService         
,SourceObjectItemService         
,SourceQueryItemService
,SourceObjectRecordItemService         
,SourceSystemItemService         
 ,EdiUsageLedgerItemService
,TransformScriptItemService         
,DirtyRecordDeploymentItemService         
,SchemaAPIItemService         
,SchemaDestinationLogItemService         
,WarehouseItemService         
,AIAnalyticsItemService         
,AIChatItemService         
,AIChatSessionItemService         
,AIChatStepItemService         
,SageCustomerItemService   
,FileStorageItemService
,DataModelItemService
,DataQueryItemService
,DataModelWorkspaceItemService
,DataModelWorkspaceArtifactVersionItemService
,DataModelWorkspaceBuildRunItemService
,UserDashboardWorkspaceStateItemService      
,SageVendorItemService} from './ItemServices';
import {ItemServiceFactory as BaseItemServiceFactory} from 'spark-core-dx/services'

export class ItemServiceFactory {

get ItemServiceEnum() {
  return {
      ...BaseItemServiceFactory.ItemServiceEnum,
    ExternalApp:"ExternalApp",
    ExternalAppSetting:"ExternalAppSetting",
    ExternalSystem:"ExternalSystem",
    ExternalSystemDirtyRecord:"ExternalSystemDirtyRecord",
    ExternalSystemDirtyScanState:"ExternalSystemDirtyScanState",
    MigrationProject:"MigrationProject",
    AIPrompt:"AIPrompt",
    AILevelProfile:"AILevelProfile",
    ConvokeAppConfig:"ConvokeAppConfig",
    DataType:"DataType",
    EntityMasterRecord:"EntityMasterRecord",
    EntityMasterRecordMap:"EntityMasterRecordMap",
    EntityObjectFieldMap:"EntityObjectFieldMap",
    EntityObject:"EntityObject",
    EntityQuery:"EntityQuery",
    RemoteBatchHost:"RemoteBatchHost",
    APIEndpointBatchHost:"APIEndpointBatchHost",
    BatchManagementPreference:"BatchManagementPreference",
    ClientBillingProfile:"ClientBillingProfile",
    Schema:"Schema",
    Integration:"Integration",
    SourceObject:"SourceObject",
    SourceQuery:"SourceQuery",
    SourceObjectRecord:"SourceObjectRecord",
    SourceSystem:"SourceSystem",
    EdiUsageLedger:"EdiUsageLedger",
    TransformScript:"TransformScript",
    DirtyRecordDeployment:"DirtyRecordDeployment",
    SchemaAPI:"SchemaAPI",
    SchemaDestinationLog:"SchemaDestinationLog",
    Warehouse:"Warehouse",
    AIAnalytics:"AIAnalytics",
    AIChat:"AIChat",
    AIChatSession:"AIChatSession",
    AIChatStep:"AIChatStep",
    SageCustomer:"SageCustomer",
    SageVendor:"SageVendor",
    FileStorage:"FileStorage",
    DataModel:"DataModel",
    DataQuery:"DataQuery",
    DataModelWorkspace:"DataModelWorkspace",
    DataModelWorkspaceArtifactVersion:"DataModelWorkspaceArtifactVersion",
    DataModelWorkspaceBuildRun:"DataModelWorkspaceBuildRun",
    UserDashboardWorkspaceState:"UserDashboardWorkspaceState"
  }
}

GetItemService(itemServiceName, coreState, coreContext, isWarning) {
    if(itemServiceName === undefined) throw new Error('Item service name not found, please regenerate the Item Services to resolve this issue.');
    let itemService;
    switch(itemServiceName.toLowerCase()){
        case this.ItemServiceEnum.ExternalApp.toLowerCase():
             itemService = new ExternalAppItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalAppSetting.toLowerCase():
             itemService = new ExternalAppSettingItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalSystem.toLowerCase():
             itemService = new ExternalSystemItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalSystemDirtyRecord.toLowerCase():
             itemService = new ExternalSystemDirtyRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalSystemDirtyScanState.toLowerCase():
             itemService = new ExternalSystemDirtyScanStateItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.MigrationProject.toLowerCase():
             itemService = new MigrationProjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIPrompt.toLowerCase():
             itemService = new AIPromptItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AILevelProfile.toLowerCase():
             itemService = new AILevelProfileItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ConvokeAppConfig.toLowerCase():
             itemService = new ConvokeAppConfigItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataType.toLowerCase():
             itemService = new DataTypeItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityMasterRecord.toLowerCase():
             itemService = new EntityMasterRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityMasterRecordMap.toLowerCase():
             itemService = new EntityMasterRecordMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObjectFieldMap.toLowerCase():
             itemService = new EntityObjectFieldMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObject.toLowerCase():
             itemService = new EntityObjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityQuery.toLowerCase():
             itemService = new EntityQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.RemoteBatchHost.toLowerCase():
             itemService = new RemoteBatchHostItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.APIEndpointBatchHost.toLowerCase():
             itemService = new APIEndpointBatchHostItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.BatchManagementPreference.toLowerCase():
             itemService = new BatchManagementPreferenceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientBillingProfile.toLowerCase():
             itemService = new ClientBillingProfileItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Schema.toLowerCase():
             itemService = new SchemaItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Integration.toLowerCase():
             itemService = new IntegrationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceObject.toLowerCase():
             itemService = new SourceObjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceQuery.toLowerCase():
             itemService = new SourceQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceObjectRecord.toLowerCase():
             itemService = new SourceObjectRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceSystem.toLowerCase():
             itemService = new SourceSystemItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EdiUsageLedger.toLowerCase():
             itemService = new EdiUsageLedgerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.TransformScript.toLowerCase():
             itemService = new TransformScriptItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DirtyRecordDeployment.toLowerCase():
             itemService = new DirtyRecordDeploymentItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaAPI.toLowerCase():
             itemService = new SchemaAPIItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaDestinationLog.toLowerCase():
             itemService = new SchemaDestinationLogItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Warehouse.toLowerCase():
             itemService = new WarehouseItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIAnalytics.toLowerCase():
             itemService = new AIAnalyticsItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChat.toLowerCase():
             itemService = new AIChatItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChatSession.toLowerCase():
             itemService = new AIChatSessionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChatStep.toLowerCase():
             itemService = new AIChatStepItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SageCustomer.toLowerCase():
             itemService = new SageCustomerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SageVendor.toLowerCase():
             itemService = new SageVendorItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.FileStorage.toLowerCase():
             itemService = new FileStorageItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModel.toLowerCase():
             itemService = new DataModelItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataQuery.toLowerCase():
             itemService = new DataQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModelWorkspace.toLowerCase():
             itemService = new DataModelWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModelWorkspaceArtifactVersion.toLowerCase():
             itemService = new DataModelWorkspaceArtifactVersionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModelWorkspaceBuildRun.toLowerCase():
             itemService = new DataModelWorkspaceBuildRunItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.UserDashboardWorkspaceState.toLowerCase():
             itemService = new UserDashboardWorkspaceStateItemService(coreState, coreContext, isWarning);
             break;
        default:
            itemService = BaseItemServiceFactory.GetItemService(itemServiceName, coreState, coreContext);
            break;
        }
        return itemService;
    }

ValidateItemName(itemName) {
    let isValid = false;
     for (const key in this.ItemServiceEnum){
        if (typeof(this.ItemServiceEnum[key]) === "string" &&
                this.ItemServiceEnum[key].toLowerCase() === itemName.toLowerCase())
                {
                    isValid = true;
                    break;
                }
        }
     return isValid || BaseItemServiceFactory.ValidateItemName(itemName);
 }
}
